// extracted by mini-css-extract-plugin
export default {"header":"styles_header__pSmrd","progressBar":"styles_progressBar__ZgHz9"};